import { useTranslation } from 'react-i18next';

const infoCards = [
  {
    icon: 'ri-map-pin-2-line',
    titleKey: 'contact_info1_title',
    line1Key: 'contact_info1_line1',
    line2Key: 'contact_info1_line2',
    actionKey: 'contact_info1_action',
    href: '#map',
    color: '#C8714A',
  },
  {
    icon: 'ri-customer-service-2-line',
    titleKey: 'contact_info2_title',
    line1Key: 'contact_info2_line1',
    line2Key: 'contact_info2_line2',
    actionKey: 'contact_info2_action',
    href: '#contact-form',
    color: '#5a8a5a',
  },
  {
    icon: 'ri-mail-line',
    titleKey: 'contact_info3_title',
    line1Key: 'contact_info3_line1',
    line2Key: 'contact_info3_line2',
    actionKey: 'contact_info3_action',
    href: 'mailto:cs@koorpet.com',
    color: '#4a7a9b',
  },
  {
    icon: 'ri-whatsapp-line',
    titleKey: 'contact_info4_title',
    line1Key: 'contact_info4_line1',
    line2Key: 'contact_info4_line2',
    actionKey: 'contact_info4_action',
    href: 'https://wa.me/5491168139526',
    color: '#25D366',
  },
];

export default function ContactInfo() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {infoCards.map((card) => (
        <div
          key={card.titleKey}
          className="bg-white rounded-2xl p-6 border border-[#f0ebe4] hover:border-[#C8714A]/30 transition-all duration-300 flex flex-col gap-4"
        >
          <div
            className="w-11 h-11 flex items-center justify-center rounded-xl"
            style={{ backgroundColor: `${card.color}15` }}
          >
            <i className={`${card.icon} text-xl`} style={{ color: card.color }}></i>
          </div>
          <div>
            <div className="text-sm font-bold text-[#1a1a1a] mb-2">{t(card.titleKey)}</div>
            <div className="text-sm text-[#666] leading-relaxed">{t(card.line1Key)}</div>
            <div className="text-sm text-[#666] leading-relaxed">{t(card.line2Key)}</div>
          </div>
          <a
            href={card.href}
            target={card.href.startsWith('http') ? '_blank' : undefined}
            rel={card.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="mt-auto inline-flex items-center gap-1.5 text-xs font-semibold cursor-pointer transition-colors whitespace-nowrap"
            style={{ color: card.color }}
          >
            {t(card.actionKey)}
            <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>
      ))}
    </div>
  );
}